"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const md_utils_1 = require("../../../export/md.utils");
const rich_text_1 = require("@vedalib/rich-text");
const toMarkdown = (element, context) => {
    if (!element.value) {
        return '';
    }
    const { image, items } = element.value;
    const sections = [];
    if (image) {
        const url = (0, md_utils_1.getFileUrl)(image, context);
        if (url) {
            sections.push(`![Labeled Image](${url})\n`);
        }
    }
    if (items && items.length > 0) {
        sections.push('**Labels:**\n');
        items.forEach((point, index) => {
            const pointParts = [];
            if (point.image) {
                const pointUrl = (0, md_utils_1.getFileUrl)(point.image, context);
                if (pointUrl) {
                    pointParts.push(`![Point ${index + 1}](${pointUrl})`);
                }
            }
            const description = point.description
                ? (0, rich_text_1.slateToMarkdown)(point.description, {
                    allowHtmlStyles: context.withStyle,
                    allowAlignment: context.withStyle,
                    allowCaptionHtml: context.withStyle,
                }).trim()
                : '';
            if (description) {
                pointParts.push(`${index + 1}. ${description}`);
            }
            if (pointParts.length > 0) {
                sections.push(pointParts.join('\n'));
            }
        });
    }
    if (sections.length === 0) {
        return '';
    }
    return sections.join('\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
